<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>

    <v-row dense
           class="d-flex justify-center mx-16">
      <v-col cols="3"
             class="mt-2">
        <v-combobox v-model="gene_select_1"
                    dense
                    clearable
                    clear-icon="mdi-close-circle"
                    :loading="gene_loading_1"
                    :items="gene_items_1"
                    :search-input.sync="gene_search_1"
                    outlined
                    rounded
                    label="Gene Name 1"
                    :messages="gene_message_1"
                    :error-messages="gene_error_message_1"
                    :disabled="is_disable_gene_1">
        </v-combobox>
      </v-col>
      <v-col cols="3"
             class="mt-2">
        <v-combobox v-model="gene_select_2"
                    dense
                    clearable
                    clear-icon="mdi-close-circle"
                    :loading="gene_loading_2"
                    :items="gene_items_2"
                    :search-input.sync="gene_search_2"
                    outlined
                    rounded
                    label="Gene Name 2"
                    :messages="gene_message_2"
                    :error-messages="gene_error_message_2"
                    :disabled="is_disable_gene_2">
        </v-combobox>
      </v-col>
      <v-col cols="3"
             class="mt-2">
        <v-select v-model="cor_select"
                  outlined
                  rounded
                  dense
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Correlation Method"
                  :items="cor_items"
                  :error-messages="cor_error_message"
                  :disabled="is_disable_cor">
        </v-select>
      </v-col>
      <v-col cols="3"
             class="mt-2">
        <v-select v-model="project_select"
                  outlined
                  rounded
                  dense
                  clearable
                  clear-icon="mdi-close-circle"
                  label="Project ID"
                  :items="project_items"
                  :error-messages="project_error_message"
                  :disabled="is_disable_project">
        </v-select>
      </v-col>

      <v-col cols="12"
             class="d-flex justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn color="info"
                   class=""
                   rounded
                   outlined
                   @click="Go()"
                   v-preventReClick
                   v-bind="attrs"
                   v-on="on"
                   :loading="go_loading"
                   :disabled="is_disable_go">
              Go !
              <v-icon right
                      small>mdi-run-fast</v-icon>
            </v-btn>
          </template>
          <span>Run!</span>
        </v-tooltip>
      </v-col>

      <v-col cols="12">
        <v-alert color="error"
                 text
                 dense
                 outlined
                 border="left"
                 elevation="1"
                 icon="mdi-information"
                 v-show="isShowNoPsiText">Sorry!
        </v-alert>
        <div class="d-flex justify-space-around"
             v-show="!isShowNoPsiText">
          <!-- {{imgURL1}} -->
          <iframe :src="imgURL1"
                  frameborder="0"
                  scrolling="no"
                  name="main"
                  width="60%"
                  :height="height">
          </iframe>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { getAllGeneFromSpliceDataset } from 'node/browse';
export default {
  name: 'GenePairCorrelation',
  components: {
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Toolkit',
          disabled: false,
          href: '/ascancer/tools',
        },
        {
          text: 'WSHY',
          disabled: true,
        },
      ],

      gene_select_1: null,
      gene_search_1: null,
      gene_items_1: [],
      gene_loading_1: false,
      gene_message_1: null,
      gene_error_message_1: null,
      is_disable_gene_1: false,

      gene_list: [],

      gene_select_2: null,
      gene_search_2: null,
      gene_items_2: [],
      gene_loading_2: false,
      gene_message_2: null,
      gene_error_message_2: null,
      is_disable_gene_2: false,

      cor_select: null,
      cor_items: ['Pearson', 'Spearman', 'Kendall'],
      cor_error_message: null,
      is_disable_cor: false,

      project_select: null,
      project_items: ["PAML_SZ", "PAML_SH"],
      project_error_message: null,
      is_disable_project: false,

      isShowNoPsiText: false,
      isShowProgress: false,
      is_disable_go: true,
      go_loading: false,

      imgURL1: "",
      height: 0,
    }
  },
  mounted() {
    this.getAllGeneFromSpliceDataset();
  },
  computed: {
    listenMultiData() {
      const { gene_select_1, gene_select_2, cor_select, project_select } = this;
      return {
        gene_select_1, gene_select_2, cor_select, project_select
      }
    },
  },
  watch: {
    imgURL1() {
      this.height = 640;
    },
    gene_search_1(val) {
      val && val !== this.gene_select_1 && this.querySelections1(val)
    },
    gene_search_2(val) {
      val && val !== this.gene_select_2 && this.querySelections2(val)
    },
    gene_select_1(val) {
      // console.log(val);
      if (val == this.$route.query.genename) {
        this.gene_select_1 = val;
        this.gene_message_1 = null;
        this.gene_error_message_1 = null;
      } else if (val == null || val == "") {
        this.gene_message_1 = "Please enter the Gene Name."
      } else if (val && this.gene_list.includes(val)) {
        this.gene_select_1 = val;
        this.gene_message_1 = null;
        this.gene_error_message_1 = null;
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.gene_select_1 = null;
      }
    },
    gene_select_2(val) {
      // console.log(val);
      if (val == this.$route.query.genename) {
        this.gene_select_2 = val;
        this.gene_message_2 = null;
        this.gene_error_message_2 = null;
      } else if (val == null || val == "") {
        this.gene_message_2 = "Please enter the Gene Name."
      } else if (val && this.gene_list.includes(val)) {
        this.gene_select_2 = val;
        this.gene_message_2 = null;
        this.gene_error_message_2 = null;
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.gene_select_2 = null;
      }
    },
    cor_select(val) {
      if (val && this.cor_items.includes(val)) {
        this.cor_select = val;
        this.cor_error_message = null;
      }
    },
    project_select(val) {
      if (val && this.project_items.includes(val)) {
        this.project_select = val;
        this.project_error_message = null;
      }
    },
    listenMultiData(val) {
      if (val.gene_select_1 && val.gene_select_2 && val.cor_select && val.project_select) {
        this.is_disable_go = false
      } else {
        this.is_disable_go = true
      }
    },
  },
  methods: {
    async getAllGeneFromSpliceDataset() {
      await getAllGeneFromSpliceDataset().then(data => {
        // console.log(data);
        if (data) {
          this.gene_list = data;
        }
      }).catch(err => console.error(err))
    },
    querySelections1(v) {
      this.gene_message_1 = null;
      this.gene_error_message_1 = null;
      this.gene_loading_1 = true;
      setTimeout(() => {
        this.gene_items_1 = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.gene_loading_1 = false
        // show the no data tips when the gene_search_1 result is null
        if (this.gene_items_1.length == 0) {
          this.gene_error_message_1 = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    querySelections2(v) {
      this.gene_message_2 = null;
      this.gene_error_message_2 = null;
      this.gene_loading_2 = true;
      setTimeout(() => {
        this.gene_items_2 = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.gene_loading_2 = false
        // show the no data tips when the gene_search_1 result is null
        if (this.gene_items_2.length == 0) {
          this.gene_error_message_2 = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    plot() {
      this.isShowProgress = true;

      this.imgURL1 = "https://ngdc.cncb.ac.cn/ascancer/wshy/expcor?gene1=" +
        this.gene_select_1 + "&gene2=" +
        this.gene_select_2 + "&cor=" +
        this.cor_select + "&project=" +
        this.project_select;
      // this.imgURL1 = "https://ngdc.cncb.ac.cn/ascancer/wshy/expcor?gene1=" +
      //   this.gene_select_1 + "&gene2=" +
      //   this.gene_select_2 + "&cor=" +
      //   this.cor_select + "&project=" +
      //   this.project_select;

      setTimeout(() => {
        this.isShowProgress = false;
        this.go_loading = false;
      }, 4000);
    },
    Go() {
      this.go_loading = true; // start go loading
      this.isShowProgress = true;
      this.plot();
    },
  },
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-progress-circular
  margin: 1rem
  left: 45%

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px
</style>